import type { MembershipPlan, Reading } from '../types/content';

// [NEED FROM ABBY: confirm pricing] — $200 is her current standard reading (1-hr session + 1 hr chart prep).
export const readings: Reading[] = [
  {
    id: 'birth-chart',
    numeral: 'I',
    name: 'Birth Chart Reading',
    tagline: 'Your Blueprint',
    description:
      'Your strengths, challenges and path across the twelve areas of life, with a focus on what matters to you now: love, career, finances or purpose.',
    duration: '60-min session',
    prep: '+ 60 min chart prep',
    price: 200,
  },
  {
    id: 'synastry',
    numeral: 'II',
    name: 'Synastry',
    tagline: 'Relationship & Compatibility',
    description:
      'Two charts overlaid to reveal how you and another person truly interact: where you flow, where you clash, how to grow together.',
    duration: '60-min session',
    prep: '+ 60 min chart prep',
    price: 200,
    badge: "Abby's Specialty",
    note: "Requires both people's birth details.",
  },
  {
    id: 'transits',
    numeral: 'III',
    name: 'Future Forecast',
    tagline: 'Transits & Timing',
    description:
      "What's moving in the sky now and how it's activating your chart in the months ahead, so you're prepared for major change.",
    duration: '60-min session',
    prep: '+ 60 min chart prep',
    price: 200,
  },
];

export const membershipPlans: MembershipPlan[] = [
  {
    id: 'love-life',
    name: 'Love Life Bundle',
    cadence: 'Multi-session synastry',
    description: 'A focused series for a relationship you want to understand deeply, from first spark to long term.',
    features: ['Synastry sessions with Abby', 'Both charts studied in full', 'Timing for key relationship moments'],
    need: 'sessions & price',
  },
  {
    id: 'seasonal',
    name: 'Seasonal Membership',
    cadence: '4 readings a year',
    description: "One reading every quarter, Abby's ideal rhythm for staying ahead of your timing all year.",
    features: ['One reading per quarter', 'Transits mapped season by season', 'Priority booking'],
    need: 'price',
    highlighted: true,
    highlightLabel: 'Recommended rhythm',
  },
  {
    id: 'inner-circle',
    name: 'Annual Inner Circle',
    cadence: '12 monthly readings',
    description: 'Monthly readings for twelve months, plus follow-up questions between sessions.',
    features: ['A reading every month', 'Follow-up questions between sessions', 'First access to new pieces'],
    need: 'price',
  },
];
